'use strict';
var Form, validator;

validator = require('../../../../../src/frontend/helper/validator');

Form = {
  init: function(signinFlyout) {
    this.signinFlyout = signinFlyout;
    this.$email = $('#ls-signin-email');
    this.$password = $('#ls-signin-pw');
    this.t = Groupon.LS.translations.userNav;
    $('#ls-signin-form').submit((function(_this) {
      return function(e) {
        return _this.submit(e);
      };
    })(this));
    this.$email.on('blur', (function(_this) {
      return function(e) {
        return _this.validateEmail(e);
      };
    })(this));
    this.$password.on('blur.signin', (function(_this) {
      return function(e) {
        return _this.validatePassword(e);
      };
    })(this));
    this.$email.on('focus', (function(_this) {
      return function(e) {
        if (!_this.$email.val() && _this.$email.parent().hasClass('error')) {
          return GIG.Forms.addError(_this.t.signInFlyoutRequiredEmail, '#ls-signin-email');
        }
      };
    })(this));
    return this.$password.on('focus', (function(_this) {
      return function(e) {
        if (!_this.$password.val() && _this.$password.parent().hasClass('error')) {
          return GIG.Forms.addError(_this.t.signInFlyoutRequiredPassword, '#ls-signin-pw');
        }
      };
    })(this));
  },
  submit: function(e) {
    var emailValid, passwordValid;
    $('#ls-signin-error').text('').hide();
    e.preventDefault();
    emailValid = this.validateEmail(e);
    passwordValid = this.validatePassword(e);
    if (!emailValid) {
      this.$email.focus();
      return false;
    } else if (!passwordValid) {
      this.$password.focus();
      return false;
    }
    $('#ls-signin-error').hide();
    return $.ajax({
      method: 'POST',
      url: '/login/iframe',
      dataType: 'json',
      data: $('#ls-signin-form').serialize(),
      success: (function(_this) {
        return function() {
          _this.signinFlyout.successMetric();
          return window.location.href = window.location.href;
        };
      })(this),
      error: (function(_this) {
        return function(err) {
          _this.$password.val('').off('blur.signin').blur();
          _this.$password.parent().removeClass('success');
          $('#ls-signin-error').text(_this.t.signInFlyoutInvalidEmailOrPassword).show();
          return _this.$password.on('blur.signin', function(ev) {
            return _this.validatePassword(ev);
          });
        };
      })(this)
    });
  },
  validateEmail: function(e) {
    var email;
    email = this.$email.val();
    if (!email) {
      setTimeout((function(_this) {
        return function() {
          var msg;
          msg = _this.$email.parent().hasClass('focused') ? _this.t.signInFlyoutRequiredEmail : _this.t.signInFlyoutRequired;
          return GIG.Forms.addError(msg, '#ls-signin-email');
        };
      })(this), 10);
      return false;
    }
    if (!validator.isEmail(email)) {
      GIG.Forms.addError(this.t.signInFlyoutInvalidEmail, '#ls-signin-email');
      return false;
    }
    GIG.Forms.removeError('#ls-signin-email');
    GIG.Forms.success('#ls-signin-email');
    return true;
  },
  validatePassword: function(e) {
    var password;
    password = this.$password.val();
    if (!password) {
      setTimeout((function(_this) {
        return function() {
          var msg;
          msg = _this.$password.parent().hasClass('focused') ? _this.t.signInFlyoutRequiredPassword : _this.t.signInFlyoutRequired;
          return GIG.Forms.addError(msg, '#ls-signin-pw');
        };
      })(this), 10);
      return false;
    }
    GIG.Forms.removeError('#ls-signin-pw');
    GIG.Forms.success('#ls-signin-pw');
    return true;
  }
};

module.exports = Form;

